import { Accordion, AccordionItem } from 'components/accordion';
import Backdrop from 'components/backdrop';
import { Tab, Tabs } from 'components/tabs';
import { Heading, ListItem, Stack } from 'components/ui';
import tickIcon from 'images/tick-icon.svg';
import { FC, useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import styled from 'styled-components';
import { breakpoints } from 'styles/theme';
const pluralize = require('pluralize');

interface InclusionsProps {
  data: Sanity.Schema.Inclusions;
}

const GridList = styled.ul`
  display: grid;
  row-gap: var(--space-1);
  list-style: none;
`;

const Inclusions: FC<InclusionsProps> = ({ data }) => {
  const specialistsData = data.specialistInclusion?.specialists || [];
  const isLarge = useMedia(`(min-width: ${breakpoints.large})`);
  const [shouldRenderTabs, setShouldRenderTabs] = useState(false);

  // Only render the tabs/accordion client side since they are dependant on the useMedia hook
  useEffect(() => {
    setShouldRenderTabs(true);
  }, []);

  return (
    <Backdrop backgroundColor='green' flourishBottomRight='small'>
      <Stack space={{ initial: 2, large: 4, xLarge: 6 }}>
        {data.specialistInclusion && (
          <>
            <Heading level='h2' color='white'>
              Specialist inclusions
            </Heading>
            {shouldRenderTabs && (
              <>
                {/* Render tabs on larger screens */}
                {isLarge ? (
                  <Tabs>
                    {specialistsData.map(({ specialist, items }, index) => (
                      <Tab
                        title={pluralize((specialist as any)?.name || '')}
                        key={specialist?._ref || '' + index}
                      >
                        <GridList>
                          {items?.map((item) => (
                            <ListItem image={tickIcon} key={item}>
                              {item}
                            </ListItem>
                          ))}
                        </GridList>
                      </Tab>
                    ))}
                  </Tabs>
                ) : (
                  // Render accordion on smaller screens
                  <Accordion>
                    {specialistsData.map(({ specialist, items }, index) => (
                      <AccordionItem
                        key={specialist?._ref || '' + index}
                        title={pluralize((specialist as any)?.name || '')}
                      >
                        <GridList>
                          {items?.map((item) => (
                            <ListItem image={tickIcon} key={item}>
                              {item}
                            </ListItem>
                          ))}
                        </GridList>
                      </AccordionItem>
                    ))}
                  </Accordion>
                )}
              </>
            )}
          </>
        )}
      </Stack>
    </Backdrop>
  );
};

export default Inclusions;
